const config = {
	fileUrl:'http://www.imedunion.com/islidem/',											// 图片访问地址
	url:"http://imedunion.com/islide"														// url请求地址
	//fileUrl:'http://localhost:8080/islidem/',												// 图片访问地址
	//url:"http://localhost:8020"
}
export default config;


// WEBPACK FOOTER //
// ./src/config/index.js